<app-slim-topbar *ngIf="guest"></app-slim-topbar>
<div class="layout-content p-0 mb-5 mt-3" [ngClass]="layoutMarginResponsive()">
	<div *ngIf="guest" class="flex align-items-center justify-content-center w-full font-semibold text-2xl my-3">
		{{'CALCULATION_POWER_PAGE_TITLE' | translate }}
	</div>
	<div class="card">
		<div class="flex align-items-center justify-content-center"
			[class]="onExtendedMobile() ? 'flex-column gap-2' : 'flex-row gap-3'">
			<div class="flex flex-column">
				<div [class]="onExtendedMobile() ? 'text-center' : 'text-center'">{{ 'BUS_SELECT_PANEL' | translate }}</div>
				<div class="flex flex-row align-items-center gap-3 ml-5">
					<p-dropdown [options]="listBus" [(ngModel)]="busSelect" (onChange)="busChange()"
						styleClass="w-20rem h-2_5rem pl-6">
						<ng-template let-item pTemplate="selectedItem">
							<div class="item" class="flex align-items-center justify-content-center text-lg">
								<div class="flex justify-content-center">{{ item.name }}</div>
							</div>
						</ng-template>
						<ng-template let-item pTemplate="item">
							<div class="item flex align-items-center justify-content-center text-lg">
								<div>{{ item.name }}</div>
							</div>
						</ng-template>
					</p-dropdown>
					<div
						class="w-2rem h-2rem flex-shrink-0 border-circle surface-border opacity-100 transition-all transition-duration-300"
						[ngStyle]="{'color': listColor[0], 'background-color': listColor[0]}">
					</div>
				</div>
				<div [class]="onExtendedMobile() ? 'text-center' : 'text-center'">
					{{ 'BUS_POWER_STANDBY' | translate }}: {{busSelect.powerGreen}}W</div>
			</div>
		</div>

		<div *ngIf="maxGateway>0" class="grid mt-0">
			<!------------------ Gateway -->
			<div class="flex flex-column gap-3" [ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<div class="flex flex-row justify-content-between">
					<div class="flex flex-row gap-3">
						<div class="font-semibold text-xl">{{ 'BUS_GATEWAY' | translate }}</div>
						<div
							class="w-2rem h-2rem flex-shrink-0 border-circle surface-border opacity-100 transition-all transition-duration-300"
							[ngStyle]="{'color': listColor[1], 'background-color': listColor[1]}">
						</div>
					</div>
				</div>
				<div class="flex flex-row align-items-center justify-content-between" *ngFor="let gateway of listGateway">
					<div class="flex flex-column justify-content-start">
						<span>{{ gateway.name | translate }}</span>
						<div class="text-sm" [class]="canAddAlertVisibleDevice(gateway)">{{ 'BUS_STANDBY' | translate
							}}:{{gateway.powerGreen}}W
						</div>
					</div>
					<div class="flex flex-row align-items-center gap-2">
						<p-button pTooltip="{{ 'REMOVE' | translate}}"
							[disabled]="gateway.disableRemove || checkSelectable(gateway)" tooltipPosition="bottom"
							icon="pi cm-minus" size="large" (click)="subtractOne(gateway)" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>
						<strong>{{ gateway.quantity }}</strong>
						<p-button pTooltip="{{ 'ADD' | translate}}"
							[disabled]="gateway.disableAdd || checkSelectable(gateway)" tooltipPosition="bottom"
							icon="pi cm-plus" size="large" (click)="addOne(gateway)" [rounded]="false" [text]="true"
							[severity]="gateway.id===4||gateway.id===5||gateway.id===6?'danger':'primary'">
						</p-button>
					</div>
				</div>
			</div>
			<!------------------ Schede -->
			<div *ngIf="maxSchede>0" class="flex flex-column gap-3" [ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<div class="flex flex-row justify-content-between">
					<div class="flex flex-row gap-3">
						<div class="font-semibold text-xl">{{ 'BUS_SCHEDE' | translate }}</div>
						<div
							class="w-2rem h-2rem flex-shrink-0 border-circle surface-border opacity-100 transition-all transition-duration-300"
							[ngStyle]="{'color': listColor[2], 'background-color': listColor[2]}">
						</div>
					</div>
				</div>
				<div class="flex flex-row align-items-center justify-content-between" *ngFor="let schede of listSchede">
					<div class="flex flex-column justify-content-start">
						<span>{{ schede.name | translate }}</span>
						<div class="text-sm" [class]="canAddAlertVisibleDevice(schede)">
							{{ 'BUS_STANDBY' | translate }}:{{schede.powerGreen}}W</div>
					</div>
					<div class="flex flex-row align-items-center gap-2">
						<p-button pTooltip="{{ 'REMOVE' | translate }}"
							[disabled]="schede.disableRemove || checkSelectable(schede)" tooltipPosition="bottom"
							icon="pi cm-minus" size="large" (click)="subtractOne(schede)" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>
						<strong>{{ schede.quantity }}</strong>
						<p-button pTooltip="{{ 'ADD' | translate }}" [disabled]="schede.disableAdd || checkSelectable(schede)"
							tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="addOne(schede)" [rounded]="false"
							[text]="true" severity="primary">
						</p-button>
					</div>
				</div>
			</div>
			<!------------------ Selettori -->
			<div *ngIf="maxSelettoriBus>0" class="flex flex-column gap-3"
				[ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<div class="flex flex-row justify-content-between">
					<div class="flex flex-row gap-3">
						<div class="font-semibold text-xl">{{ 'BUS_SELECTORS_BUS' | translate }}</div>
						<div
							class="w-2rem h-2rem flex-shrink-0 border-circle surface-border opacity-100 transition-all transition-duration-300"
							[ngStyle]="{'color': listColor[3], 'background-color': listColor[3]}">
						</div>
					</div>
					<span class="mr-3" [ngClass]="{'text-50' : totalSelettoriBus === maxSelettoriBus}">
						{{ 'BUS_MAX' | translate }}: {{totalSelettoriBus}}/{{maxSelettoriBus}}
					</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let selettore of listSelettoriBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ selettore.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(selettore)">
								{{ 'BUS_STANDBY' | translate }}:{{selettore.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="selettore.disableRemove || checkSelectable(selettore)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(selettore)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
							<strong>{{ selettore.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="selettore.disableAdd || checkSelectable(selettore)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(selettore)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
			<!-- COLL -->
			<div *ngIf="maxLampeggiantiBus>0 || maxInterfaccieBus>0 || maxFotocelluleBus>0" class="flex flex-column gap-3"
				[ngClass]="col3Responsive() + ' ' + customPaddingX()">
				<!------------------ Fotocellule -->
				<div class="flex flex-row justify-content-between">
					<div class="flex flex-row gap-3">
						<div class="font-semibold text-xl">{{ 'BUS_PHOTOCELLS_BUS' | translate }}</div>
						<div
							class="w-2rem h-2rem flex-shrink-0 border-circle surface-border opacity-100 transition-all transition-duration-300"
							[ngStyle]="{'color': listColor[4], 'background-color': listColor[4]}">
						</div>
					</div>
					<span class="mr-3" [ngClass]="{'text-50' : totalFotocelluleBus === maxFotocelluleBus}">{{ 'BUS_MAX' |
						translate }}:
						{{totalFotocelluleBus}}/{{maxFotocelluleBus}}
					</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let fotocellula of listFotocelluleBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ fotocellula.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(fotocellula)">
								{{ 'BUS_STANDBY' | translate }}:{{fotocellula.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="fotocellula.disableRemove || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(fotocellula)" [rounded]="false"
								[text]="true" severity="primary">
							</p-button>
							<strong>{{ fotocellula.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="fotocellula.disableAdd || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(fotocellula)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
				<!------------------ Interfaccie -->
				<div class="flex flex-row justify-content-between">
					<div class="flex flex-row gap-3">
						<div class="font-semibold text-xl">{{ 'BUS_INTERFACES_BUS' | translate }}</div>
						<div
							class="w-2rem h-2rem flex-shrink-0 border-circle surface-border opacity-100 transition-all transition-duration-300"
							[ngStyle]="{'color': listColor[5], 'background-color': listColor[5]}">
						</div>
					</div>
					<span class="mr-3" [ngClass]="{'text-50' : totalInterfaccieBus === maxInterfaccieBus}">{{ 'BUS_MAX' |
						translate }}:
						{{totalInterfaccieBus}}/{{maxInterfaccieBus}}
					</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let interfaccia of listInterfaccieBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ interfaccia.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(interfaccia)">
								{{ 'BUS_STANDBY' | translate }}:{{interfaccia.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="interfaccia.disableRemove || checkSelectable(interfaccia)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(interfaccia)" [rounded]="false"
								[text]="true" severity="primary">
							</p-button>
							<strong>{{ interfaccia.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="interfaccia.disableAdd || checkSelectable(interfaccia)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(interfaccia)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
				<!------------------ Lampeggianti -->
				<div class="flex flex-row justify-content-between">
					<div class="flex flex-row gap-3">
						<div class="font-semibold text-xl">{{ 'BUS_FLASHING_BUS' | translate }}</div>
						<div
							class="w-2rem h-2rem flex-shrink-0 border-circle surface-border opacity-100 transition-all transition-duration-300"
							[ngStyle]="{'color': listColor[6], 'background-color': listColor[6]}">
						</div>
					</div>
					<span class="mr-3" [ngClass]="{'text-50' : totalLampeggiantiBus === maxLampeggiantiBus}">{{ 'BUS_MAX'
						|
						translate }}:
						{{totalLampeggiantiBus}}/{{maxLampeggiantiBus}}
					</span>
				</div>
				<div class="flex flex-column gap-3">
					<div class="flex flex-row align-items-center justify-content-between"
						*ngFor="let lampeggiante of listLampeggiantiBus">
						<div class="flex flex-column justify-content-start">
							<span>{{ lampeggiante.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(lampeggiante)">
								{{ 'BUS_STANDBY' | translate }}:{{lampeggiante.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="lampeggiante.disableRemove || checkSelectable(lampeggiante)"
								tooltipPosition="bottom" icon="pi cm-minus" size="large" (click)="subtractOne(lampeggiante)"
								[rounded]="false" [text]="true" severity="primary">
							</p-button>
							<strong>{{ lampeggiante.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="lampeggiante.disableAdd || checkSelectable(lampeggiante)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(lampeggiante)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div>
			<!-- COLL -->
			<div *ngIf="maxFotocelluleOld>0 || maxSelettoriOld>0 || maxLampeggiantiOld>0" class="flex flex-column gap-3"
				[ngClass]="col3Responsive() + ' ' + customPaddingX()" style="height: 400px;">
				<!------------------ Selettori -->
				<div class="flex flex-row justify-content-between" *ngIf="maxSelettoriOld>0">
					<div class="flex flex-row gap-3">
						<div class="font-semibold text-xl">{{ 'BUS_SELECTORS_OLD' | translate }}</div>
						<div
							class="w-2rem h-2rem flex-shrink-0 border-circle surface-border opacity-100 transition-all transition-duration-300"
							[ngStyle]="{'color': listColor[7], 'background-color': listColor[7]}">
						</div>
					</div>
					<span class="mr-3" [ngClass]="{'text-50' : totalSelettoriOld === maxSelettoriOld}">{{ 'BUS_MAX' |
						translate }}:
						{{totalSelettoriOld}}/{{maxSelettoriOld}}
					</span>
				</div>
				<div class="flex flex-column gap-3" *ngIf="maxSelettoriOld>0">
					<div class="flex flex-row align-items-center justify-content-between gap-8"
						*ngFor="let selettori of listSelR">
						<div class="flex flex-column justify-content-start">
							<span>{{ selettori.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(selettori)">
								{{ 'BUS_STANDBY' | translate }}:{{selettori.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="selettori.disableRemove || checkSelectable(selettori)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(selettori)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
							<strong>{{ selettori.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="selettori.disableAdd || checkSelectable(selettori) || enabledAddWithBoard(selettori)"
								tooltipPosition="bottom" icon="pi cm-plus" size="large" (click)="addOne(selettori)"
								[rounded]="false" [text]="true" severity="primary">
							</p-button>
						</div>
					</div>
				</div>
				<!------------------ Fotocellule -->
				<div class="flex flex-row justify-content-between gap-2" *ngIf="maxFotocelluleOld>0">
					<div class="flex flex-row">
						<div class="font-semibold text-xl">{{ 'BUS_PHOTOCELLS_OLD' | translate }}</div>
						<!-- <div
							class="w-2rem h-2rem flex-shrink-0 border-circle surface-border opacity-100 transition-all transition-duration-300"
							[ngStyle]="{'color': listColor[8], 'background-color': listColor[8]}">
						</div> -->
					</div>
					<span class="mr-3" [ngClass]="{'text-50' : totalFotocelluleOld === maxFotocelluleOld}">{{ 'BUS_MAX' |
						translate }}:
						{{totalFotocelluleOld}}/{{maxFotocelluleOld}}
					</span>
				</div>
				<div class="flex flex-column gap-3" *ngIf="maxFotocelluleOld>0">
					<div class="flex flex-row align-items-center justify-content-between gap-8"
						*ngFor="let fotocellula of listFotocell">
						<div class="flex flex-column justify-content-start">
							<span>{{ fotocellula.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(fotocellula)">
								{{ 'BUS_STANDBY' | translate }}:{{fotocellula.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="fotocellula.disableRemove || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-minus" size="large" (click)="subtractOne(fotocellula)" [rounded]="false"
								[text]="true" severity="primary">
							</p-button>
							<strong>{{ fotocellula.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="fotocellula.disableAdd || checkSelectable(fotocellula)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(fotocellula)" [rounded]="false" [text]="true"
								[severity]="fotocellula.id===2?'danger':'primary'">
							</p-button>
						</div>
					</div>
				</div>
				<!------------------ Lampeggianti -->
				<div class="flex flex-row justify-content-between" *ngIf="maxLampeggiantiOld>0">
					<div class="flex flex-row gap-3">
						<div class="font-semibold text-xl">{{ 'BUS_FLASHING_OLD' | translate }}</div>
						<!-- <div
							class="w-2rem h-2rem flex-shrink-0 border-circle surface-border opacity-100 transition-all transition-duration-300"
							[ngStyle]="{'color': listColor[9], 'background-color': listColor[9]}">
						</div> -->
					</div>
					<span class="mr-3" [ngClass]="{'text-50' : totalLampeggiantiOld === maxLampeggiantiOld}">{{ 'BUS_MAX'
						|
						translate }}:
						{{totalLampeggiantiOld}}/{{maxLampeggiantiOld}}
					</span>
				</div>
				<div class="flex flex-column gap-3" *ngIf="maxLampeggiantiOld>0">
					<div class="flex flex-row align-items-center justify-content-between gap-8"
						*ngFor="let lampeggianti of listLampeggiantiOld">
						<div class="flex flex-column justify-content-start">
							<span>{{ lampeggianti.name | translate }}</span>
							<div class="text-sm" [class]="canAddAlertVisibleDevice(lampeggianti)">
								{{ 'BUS_STANDBY' | translate }}:{{lampeggianti.powerGreen}}W</div>
						</div>
						<div class="flex flex-row align-items-center gap-2">
							<p-button pTooltip="{{ 'REMOVE' | translate}}"
								[disabled]="lampeggianti.disableRemove || checkSelectable(lampeggianti)"
								tooltipPosition="bottom" icon="pi cm-minus" size="large" (click)="subtractOne(lampeggianti)"
								[rounded]="false" [text]="true" severity="primary">
							</p-button>
							<strong>{{ lampeggianti.quantity }}</strong>
							<p-button pTooltip="{{ 'ADD' | translate}}"
								[disabled]="lampeggianti.disableAdd || checkSelectable(lampeggianti)" tooltipPosition="bottom"
								icon="pi cm-plus" size="large" (click)="addOne(lampeggianti)" [rounded]="false" [text]="true"
								severity="primary">
							</p-button>
						</div>
					</div>
				</div>
			</div><!-- COLL GRAPH -->
			<div class="flex flex-column gap-3" [ngClass]="calcCollGraph()+ ' '+ col3Responsive() + ' '">
				<div class="text-lg font-semibold {{statusLimitGreenPower===2?'text-50':''}}">
					{{ 'BUS_MAX_POWER_GREEN_MODULE' | translate }}</div>
				<p-meterGroup [value]="valueGreenPower">
					<ng-template pTemplate="label">
					</ng-template>
					<ng-template pTemplate="start" let-totalPercent="totalPercent">
						<div class="flex justify-content-between relative">
							<span class="font-medium">0 W</span>
							<span style="border-left: 1px solid black;
									height: 40px; position: absolute; top: 20px;
									left: 0%;"></span>
							<span class="font-medium">{{ 'BUS_MAX' | translate }}: Watt</span>
							<span style="border-left: 1px solid black;
									height: 40px; position: absolute; top: 20px;
									left: 100%;"></span>
						</div>
					</ng-template>
				</p-meterGroup>
			</div>
		</div>
	</div>
</div>
<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<!--<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>-->
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>

<app-buscalculation-footer *ngIf="guest"></app-buscalculation-footer>